import { findKey, max, values } from 'lodash';
import { ProbabilityByLabel } from './types';

export function predictedLabel(predictions: ProbabilityByLabel): string {
  const consensusLabel = findKey(predictions, value => value === max(values(predictions)));
  return consensusLabel || '?';
}
